require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./parents-centre-forms-and-handbooks.json") })
        }
      }, "path---parents-centre-forms-and-handbooks");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---parents-centre-forms-and-handbooks!./.cache/json/parents-centre-forms-and-handbooks.json
// module id = 1246
// module chunks = 231608221292675